/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unpauseNeighborhoodProgram} from '../api'

export const useMutationUnpauseNeighborhoodProgram = createReactQueryMutationHook('unpauseNeighborhoodProgram', unpauseNeighborhoodProgram)
